import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import { filterBy } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { NumericCell } from "../DibursementPayment/DisbursementInputField";
import { v4 as uuidV4 } from "uuid";
import { Form, FormElement,  Field} from "@progress/kendo-react-form";
import * as api from "../../api/index";
import { AmountFormatCell } from "components/common/formatter";
import { Button } from "@progress/kendo-react-buttons";
import { useState, useEffect } from "react";
import SearchComboBox from "components/common/SearchComboBox";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import { Label } from "@progress/kendo-react-labels";
import { useActiveVats } from "services/vatService";
import { useActiveFeeEarner } from "services/userService";

const BillExpenseGrid = (props) => {
  const initialData = [
    {
      timeId: uuidV4(),
      type: "Expense",
      date: new Date(),
      details: "",
      netAmount: 0,
      vatAmount: 0,
      gross: 0,
      vatCode: 0,
    },
  ];

  const allInEdit = initialData.map((item) =>
    Object.assign(
      {
        inEdit: true,
      },
      item
    )
  );
  const [data, setData] = React.useState(allInEdit);
  const [error, setError] = useState(undefined);
  const [error1, setError1] = useState(undefined);

  const [vatvalue, setvatvalue] = useState();
  const [vatsdata, setvatsData] = React.useState();
  const [nominal, setnominal] = useState();
  const [nominaldata, setnominaldata] = React.useState();
  const [feeearner, setfeeearnerData] = React.useState();

  const { data: activevatsdata = [] } = useActiveVats();

  const { data: feeearnerdata } = useActiveFeeEarner();

  const calculateVatGross = () => {
    data.map((item) => {
      if (item.netAmount !== undefined || item.netAmount !== null) {
        item.vatAmount = (vatvalue?.rate / 100) * item.netAmount;
        item.gross = item.netAmount + item.vatAmount;
      }
    });
  };
  const addNew = () => {
    const uniqueTimeId = uuidV4();
    const newDataItem = {
      inEdit: true,
      timeId: uniqueTimeId,
      type: "Expense",
      date: new Date(),
      details: "",
      netAmount: 0,
      vatAmount: 0,
      gross: 0,
      vatCode: 0,
    };
    setData([...data, newDataItem]);
  };

  const onChangenominal = (event) => {
    setnominal(event.value);
  };
  const onChangevat = (event) => {
    setvatvalue(event.value);
    if (event.value !== null || event.value !== undefined) {
      data.map((item) => {
        if (item.netAmount !== undefined || item.netAmount !== null) {
          item.vatAmount = (event.netAmount?.rate / 100) * item.netAmount;
          item.gross = item.netAmount - item.vatAmount;
        }
      });
    }
  };
  const filterData = (filter) => {
    const datas = activevatsdata.slice();
    return filterBy(datas, filter);
  };

  const filterChange = (event) => {
    setvatsData(filterData(event.filter));
  };
  const filternominalData = (filter) => {
    const data = nominallist.slice();
    return filterBy(data, filter);
  };
  const filternominal = (event) => {
    setnominaldata(filternominalData(event.filter));
  };

  const nominallist = useSelector((state) => {
    let array = [];
    let list = state.nominalList.activenominals.data.map((item) => {
      if (item.subType === "ProfitAndLoss_Income") {
        const templist = item;
        templist.representation = item.nominalRef + "  -  " + item.nominalName;
        array.push(item);
        return templist;
      }
    });
    return array;
  });

  const handleSubmit = (values) => {
    if (!vatvalue || !nominal.nominalRef || !values.feeEarner) {
      setError(true);
      return;
    }
    data.map((item) => {
      item.feeEarnerRef = values.feeEarner?.userRef;
      item.nominalRef = nominal?.nominalRef;
      item.vatCode = vatvalue?.vatCodeId;
    });
    if (data === 0) {
      setError1(true);
      return;
    }

    props.changeMatterList(data);
    const uniqueTimeId = uuidV4();
    setData([{ inEdit: true, timeId: uniqueTimeId }]);
    props.cancelEdit();
  };
  const itemChange = (e) => {
    let newData = data.map((item) => {
      if (item.timeId === e.dataItem.timeId) {
        item[e.field || ""] = e.value;
      }
      return item;
    });
    setData(newData);
    if (e.field === "netAmount") {
      calculateVatGross();
    }
  };

  const addDefaultValues = () => {
    setvatvalue(
      activevatsdata.find(
        (item) => item.vatCodeId == props.defaultValues?.defaultVatCodeId
      )
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setvatsData(activevatsdata.slice());
      setfeeearnerData(feeearnerdata.slice());
      addDefaultValues();
    }, 100);
  }, []);

  const requiredValidator = (value) => {
    return value ? undefined : "invalid"; // triggers k-invalid class
  };

  const getNominals = async () => {
    const { data } = await api.getactivenominals();
    let array = [];

    let list = data.data.map((item) => {
      if (item.subType === "ProfitAndLoss_Expense") {
        const templist = item;
        templist.representation = item.nominalRef + "  -  " + item.nominalName;
        array.push(item);
        return templist;
      }
    });
    return array;
  };

  const fetchNominal = async () => {
    const data = await getNominals();
    setnominaldata(data.slice());
    setnominal(
      data.find(
        (item) => item.nominalRef == props.defaultValues?.defaultProfitNominal
      )
    );
  };

  useEffect(() => {
    fetchNominal();
  }, []);

   console.log('ok' , vatvalue)

  return (
    <Dialog title={`Expenses`} onClose={props.cancelEdit} width={"1100px"}>
      <>
        <div className="d-flex flex-column pt-4 pb-3 px-5">
          <div className="d-flex flex-wrap align-items-center validation">
            <Form
              ignoreModified={true}
              onSubmit={handleSubmit}
              id="timeRecord"
              // initialValues={initialData}
              // key={JSON.stringify(initialData)}
              render={(formRenderProps) => {
                return (
                  <div>
                    <FormElement id="timeRecord" name="timeRecord">
                      <fieldset>
                        {formRenderProps.visited &&
                          formRenderProps.errors &&
                          formRenderProps.errors.VALIDATION_SUMMARY && (
                            <div className={"k-messagebox k-messagebox-error"}>
                              {formRenderProps.errors.VALIDATION_SUMMARY}
                            </div>
                          )}

                        <div className="d-flex">
                          <div
                            className="d-flex flex-column mb-3 me-3"
                            style={{ width: "300px" }}
                          >
                            <Label>Vat Code</Label>
                            <Field
                              name="vatCode"
                              component={ComboBox}
                              validator={requiredValidator}
                              validationMessage="" // suppresses error text
                              style={{ width: "300px" }}
                              className="mt-1"
                              data={activevatsdata}
                              textField="display"
                              filterable={true}
                              onFilterChange={filterChange}
                              value={vatvalue}
                              iconClassName="wa"
                              onChange={onChangevat}
                              placeholder="Search VAT Code"
                            />
                          </div>

                          <div
                            className="d-flex flex-column mb-3 me-3"
                            style={{ width: "300px" }}
                          >
                            <Label>Nominal Ref</Label>
                            <Field
                              name="nominalRef"
                              component={ComboBox}
                              validator={requiredValidator}
                              validationMessage=""
                              className="mt-1"
                              style={{ width: "300px" }}
                              data={nominaldata}
                              iconClassName="wa"
                              textField="representation"
                              filterable={true}
                              onFilterChange={filternominal}
                              value={nominal}
                              onChange={onChangenominal}
                              placeholder="Search Nominal Ref"
                            />
                          </div>

                          <div className="mb-3">
                            <Field
                              name="feeEarner"
                              component={SearchComboBox}
                              cbType={CONSTANT.FE}
                              validator={requiredValidator}
                              validationMessage=""
                              className="mt-1"
                              iconClassName="wa"
                              width="300px"
                              placeholder="Search Fee Earner Ref"
                              defaultValues={props.defaultValues}
                              defaultValueSetter={formRenderProps}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </FormElement>
                  </div>
                );
              }}
            />
          </div>

          <Grid
            data={data}
            className="grid-header-sm mt-1"
            style={{ height: "370px", overflow: "auto" }}
            editField="inEdit"
            onItemChange={itemChange}
            dataItemKey={"timeId"}
          >
            <Column
              field="date"
              editor="date"
              title="Date"
              format="{0:d}"
              width={"200px"}
              className="p-2"
              headerClassName="ps-3"
            />
            <Column field="details" title="Details" width={"200px"} />
            <Column
              field="netAmount"
              editor="numeric"
              title="Value"
              cell={NumericCell}
              className="p-2"
            />
            <Column
              field="vatAmount"
              title="Vat"
              editable={false}
              cell={AmountFormatCell}
              className="p-2"
            />
            <Column
              field="gross"
              title="Gross"
              editable={false}
              cell={AmountFormatCell}
              className="p-2"
            />
          </Grid>

          {error1 === true && (
            <i style={{ color: "red" }}>Select atleast 1 Record</i>
          )}
          <div>
            <Button
              title="Add new"
              className="common-btn thirdButton"
              style={{ marginTop: "10px" }}
              onClick={addNew}
            >
              Add new line
            </Button>
          </div>
        </div>

        <div className="dialog-footer">
          <button
            className="common-btn bgBtnSecondary border-0 me-3"
            onClick={() => {
              props.cancelEdit();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="timeRecord"
            className="k-button common-btn me-4"
          >
            Select
          </button>
        </div>
      </>
    </Dialog>
  );
};

export default BillExpenseGrid;
